<template>
    <div>
        <!-- Modals -->
        <TextModal
            :modalTitle="'Conditions d\'utilisation de ce service'"
            :showModal.sync="showModal"
            :modalText="getModalText"
            modalClass="due-cgu"
        ></TextModal>
        <!-- Modals -->

        <div class="content-wrapper content-wrapper-exemption">
            <div class="img-desktop img-desktop-create d-lg-inline-block img-desktop-employee"></div>
          <div class="no-autorized__img"></div>
            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2 alert-container"></div>
                </div>
            </section>

            <section class="content create-due-content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-11 form-request-content-large">
                            <div class="request-title">
                                <h1>Signer ma DUE</h1>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-10 form-request-content-large">
                        <div class="required-field-text">Champs obligatoires</div>
                        <div class="row">
                            <div class="col-md-8">
                                <div class="motif-due-border">
                                    <h2>Information des salariés</h2>
                                    <div v-if="legalInformation">
                                        <p v-for="(legalAdvice, index) in legalInformation.informationForEmployees.legalAdvice"
                                           :key="index"
                                           class="input-legend due-motifs-help-text"
                                        >{{ legalAdvice }}</p>
                                    </div>
                                </div>
                                <div class="motif-due-border motif-due-border-information">
                                    <h2>Garantie de conformité</h2>
                                    <p v-if="legalInformation"
                                       class="input-legend due-motifs-help-text"
                                    >{{ legalInformation.guaranteeOfConformity.legalAdvice }}</p>

                                </div>
                                <div class="form-group">
                                    <form
                                            name="exemption"
                                            method="post"
                                            enctype="multipart/form-data"
                                            novalidate="novalidate"
                                            class="needs-validation"
                                    >
                                        <!-- Phone Number -->
                                        <div class="form-group">
                                            <label for="phone">Téléphone</label>
                                            <div class="input-group" >
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">
                                                        <i class="fas fa-phone"></i>
                                                    </span>
                                                </div>
                                                <masked-input
                                                        type="tel"
                                                        mask="\+\33 1 11 11 11 11"
                                                        id="phone"
                                                        class="form-control"
                                                        :class="{ 'is-invalid': $v.formData.phoneNumber.$error }"
                                                        @input="maskedDelayTouch($v.formData.phoneNumber)"
                                                        v-model="formData.phoneNumber"
                                                />
                                            </div>
                                            <FormError error="Le numéro de téléphone doit contenir 11 chiffres"
                                                       v-if="!$v.formData.phoneNumber.phoneLength && $v.formData.phoneNumber.$dirty"
                                            ></FormError>
                                            <FormError error="Le numéro de téléphone doit  respecter le format suivant : 6 50 67 89 23"
                                                       v-if="!$v.formData.phoneNumber.phoneFormat && $v.formData.phoneNumber.$dirty"
                                            ></FormError>
                                            <p v-if="legalInformation"
                                               class="input-legend"
                                            >{{ legalInformation.legalRepresentativePhone.legalAdvice }}</p>
                                        </div>
                                        <!-- Phone Number -->
                                        <div class="check-container">
                                            <div class="form-group clearfix">
                                                <div class="icheck-primary d-inline">
                                                    <input type="checkbox"
                                                           id="dueCheckbox"
                                                           v-model="formData.isPolicyAccepted"
                                                    >
                                                    <label for="dueCheckbox">
                                                        <span>J'ai lu et j'accepte les </span>
                                                        <a @click.prevent="handleOpenPopup"
                                                        >Conditions d'utilisation de ce service</a>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div class="col-md-4 col-xl-3 due-seventh-step-card">
                                <div class="info-card seventh-step-card-item">
                                    <span class="badge badge-danger">PDF</span>
                                    <h5 class="mt-2">
                                        <span>DUE: </span>
                                        <span v-if="due"
                                              v-text="`${(due.collectiveAgreement || {}).codeIdcc || ''} ${(due.collectiveAgreement || {}).name || ''}`.trim()"
                                        ></span>
                                    </h5>
                                    <div class="intro">Attention ce document n'a pas encore de valeur juridique</div>
                                    <img src="@/assets/img/orangePill.svg" class="due-document-orange-pill">
                                    <button class="btn__export--due"
                                            :disabled=" downloadDueIsLoading"
                                            @click="downloadDue"
                                    >
                                        <span>Consulter</span>
                                        <ButtonSpinner :isLoading="downloadDueIsLoading"></ButtonSpinner>
                                    </button>
                                </div>
                                <div class="info-card seventh-step-card-item"
                                     v-if="formData.particularConditions"
                                >
                                    <h5 class="mt-2">Les conditions particulières</h5>
                                    <img src="@/assets/img/orangePill.svg" class="due-document-orange-pill">
                                    <button class="btn__export--due"
                                            @click.prevent="downloadDocument('particularConditions')"
                                    >Télécharger</button>
                                </div>
                                <div class="info-card seventh-step-card-item"
                                     v-if="formData.copyOfInformationNote"
                                >
                                    <h5 class="mt-2">Copie de la notice d’information</h5>
                                    <img src="@/assets/img/orangePill.svg" class="due-document-orange-pill">
                                    <button class="btn__export--due"
                                            @click.prevent="downloadDocument('copyOfInformationNote')"
                                    >Télécharger</button>
                                </div>
                                <div class="info-card seventh-step-card-item"
                                     v-if="formData.particularConditionsForOptionalContract"
                                >
                                    <h5 class="mt-2">Les conditions particulières du contrat facultatif</h5>
                                    <img src="@/assets/img/orangePill.svg" class="due-document-orange-pill">
                                    <button class="btn__export--due"
                                            @click.prevent="downloadDocument('particularConditionsForOptionalContract')"
                                    >Télécharger</button>
                                </div>
                                <div class="info-card seventh-step-card-item"
                                     v-if="formData.copyOfInformationNoteForOptionalContract"
                                >
                                    <h5 class="mt-2">La notice d'information du contrat facultatif</h5>
                                    <img src="@/assets/img/orangePill.svg" class="due-document-orange-pill">
                                    <button class="btn__export--due"
                                            @click.prevent="downloadDocument('copyOfInformationNoteForOptionalContract')"
                                    >Télécharger</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="input-group col-md-10 mx-sm-auto my-md-4">
                        <div class="mx-sm-auto">
                            <button class="btn btn-success btn-lg ml-4 btn-link btn__save"
                                    :disabled="submitIsLoading || $v.$invalid"
                                    @click.prevent="sign"
                            >
                                <span>Je signe ma DUE</span>
                                <ButtonSpinner :isLoading="submitIsLoading"></ButtonSpinner>
                            </button>
                        </div>
                    </div>


                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import ButtonSpinner from '../../components/ButtonSpinner';
    import DueDocumentManager from '../../mixins/dueDocumentManager';
    import DueSixthStepManager from '../../service/manager/due/sixthStepManager';
    import FormError from '../../components/FormError';
    import MaskedInput from 'vue-masked-input';
    import ValidationDelayTouch from '../../mixins/validationDelayTouch';
    import TextModal from '../../components/modal/TextModal';
    import { phoneNumberConstraint, phoneNumberFormat } from '../../utils/validation';
    import { trimSpaces } from '../../utils/utils';
    import { required } from 'vuelidate/lib/validators';
    import {
        fetchDueLegalInformationByDueAccessToken,
        fetchDueLegalRepresentativeByAccessToken,
        legalRepresentativeDownloadDueByAccessToken,
        startDueSignByAccessToken
    } from '../../service/api/dues.api';

    export default {
        mixins: [DueDocumentManager, ValidationDelayTouch],
        data() {
            return {
                formData: {
                    particularConditions: null,
                    copyOfInformationNote: null,
                    particularConditionsForOptionalContract: null,
                    copyOfInformationNoteForOptionalContract: null,
                    phoneNumber: '',
                    isPolicyAccepted: false
                },
                due: null,
                submitIsLoading: false,
                downloadDueIsLoading: false,
                showModal: false,
                legalInformation: null
            };
        },
        async mounted() {
            await this.fetchDueLegalInformationByDueToken();
            await this.fetchDueByAccessToken();
        },
        computed: {
            accessToken() {
                return this.$route.params.dueAccessToken;
            },
            getModalText() {
                return this.legalInformation && this.legalInformation.dueGeneralConditionsOfUsageLegalAdviceText
                    ? this.legalInformation.dueGeneralConditionsOfUsageLegalAdviceText.legalAdvice
                    : null
                ;
            }
        },
        methods: {
            async sign() {
                try {
                    this.submitIsLoading = true;
                    const { data } = await startDueSignByAccessToken(
                        this.accessToken,
                        trimSpaces(this.formData.phoneNumber),
                        this.formData.isPolicyAccepted
                    );
                    window.location.href = data.url;
                } catch ({ response }) {
                    this.submitIsLoading = false;
                    await this.$router.push({ name: 'oops', params: { messageShortCode: 'due_token_expired' }});
                }
            },
            async fetchDueByAccessToken() {
                try {
                    const { data } = await fetchDueLegalRepresentativeByAccessToken(this.accessToken);
                    this.formData = {
                        ...this.formData,
                        ... await DueSixthStepManager.createFormDataFromResponse(data)
                    };
                    this.due = data;
                } catch ({ response }) {
                    await this.$router.push({ name: 'oops', params: { messageShortCode: 'due_token_expired' }});
                }
            },
            async fetchDueLegalInformationByDueToken() {
                try {
                    const { data } = await fetchDueLegalInformationByDueAccessToken(this.accessToken);

                    this.legalInformation = data
                } catch (error) {
                    await this.$router.push({ name: 'oops', params: { messageShortCode: 'due_token_expired' }});
                }
            },
            async downloadDue() {
                try {
                    this.downloadDueIsLoading = true;
                    await legalRepresentativeDownloadDueByAccessToken(this.accessToken);
                    this.downloadDueIsLoading = false;
                } catch ({ response }) {
                    this.downloadDueIsLoading = false;
                }
            },
            handleOpenPopup() {
                window.scrollTo({ top: 0, left: 0, behaviour: 'smooth' });
                this.showModal = true;
            }
        },
        validations: {
            formData: {
                isPolicyAccepted: {
                    checked: (value) => {
                        return value === true;
                    }
                },
                phoneNumber: {
                    phoneLength: phoneNumberConstraint,
                    phoneFormat: phoneNumberFormat,
                    required
                }
            }
        },
        components: {
            ButtonSpinner,
            FormError,
            MaskedInput,
            TextModal
        }
    }
</script>
